export default __webpack_public_path__ + "static/media/skills.1e27e7de.svg";